import React, { FunctionComponent, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import University from '../../networking/models/University';
import Rating from '../layout/Rating';
import HanButton from './HanButton';
import MediaAccountList from '../client/partials/MediaAccountList';
import FavoriteIcon from '../client/partials/university/FavoriteIcon';
import HanCheckbox from './HanCheckbox';
import {useFavorites} from '../../contexts/FavoritesContext';
import {route} from 'b302-frontend-library';

interface Props {
  university: University;

  selected?: boolean;
  onCompareClick?: (university: University) => void;
}

const UniversityCard: FunctionComponent<Props> = ({ university, selected, onCompareClick }) => {
    const navigate = useNavigate();

    const { toggleFavorite, favoriteUniversities } = useFavorites();

    const description = useMemo(() => {
        let description = university.description ?? '';

        if(description.length > 392) {
            description = description.substring(0, description.length - (description.length - 395)) + '...';
        }

        return description;
    }, [university]);

    const openUniversity = () => {
        navigate(route('university-detail', university));
    };

    const image = university.images?.length ? university.images[0].url : 'https://www.leidenuniversitygreenoffice.nl/wp-content/uploads/2021/10/3.jpg';

    return (
        <div className={'university-card'}>
            <img className="university-card__image" alt={university.name} src={image} />

            <div className={'university-card__info'}>
                <div className={'university-card__title-container'}>
                    <div className={'university-card__title'}>
                        <h4 className={'university-card__text-title'}>{ university.name }</h4>

                        <FavoriteIcon
                            active={favoriteUniversities.includes(university.id!)}
                            onClick={() => toggleFavorite(university.id!)}
                            className={'university-card__icon'}/>
                    </div>

                    {/* <Rating rating={university.rating!} size={'small'} sideText={`(${university.responses} responses)`} /> */}
                </div>

                <div>
                    <span className={'university-card__text'}>{ university.country?.name }</span>
                    <span className={'university-card__text'}>{ university.city ?? 'No city' }</span>
                </div>
            </div>

            <div className={'university-card__footer'}>
                <div>
                    { onCompareClick &&
                        <div className={'university-card__checkbox-container university-card__checkbox-container--mobile'}>
                            <HanCheckbox onClick={() => onCompareClick(university)} checked={selected} />
                        </div>
                    }

                    <div className={'university-card__desc'}>
                        <span className={'university-card__text university-card__text--desc'}>
                            { description }
                        </span>
                    </div>

                    <div className={'university-card__actions'}>
                        <div className={'flex flex--align-center'}>
                            <HanButton onClick={openUniversity} arrow>More information</HanButton>
                            { onCompareClick &&
                                <div className={'university-card__checkbox-container university-card__checkbox-container--desktop'}>
                                    <HanCheckbox onClick={() => onCompareClick(university)} checked={selected} />
                                    <span>Compare</span>
                                </div>
                            }
                        </div>

                        <MediaAccountList accounts={university.socialMediaAccounts!} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UniversityCard;
